/* Preserve lazySizes initialization after its deferred dependency on the home page. */
(function () {
  'use strict';
  window.lazySizes.init();
})();
